"use strict";

var diagnostics = {
  trace: trace,
  enabled: false,
  devtoolsEnabled: false };

module.exports = diagnostics;

function trace() {
  if (diagnostics.enabled) {
    console && console.log.apply(console, arguments);
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/diagnostics.js
 ** module id = 440
 ** module chunks = 0
 **/